// app/javascript/controllers/nested_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "row"]
  static values = { nextIndex: Number }

  connect() {
    // Авто-инициализация nextIndex: max существующего индекса + 1
    if (isNaN(this.nextIndexValue)) {
      this.nextIndexValue = this.maxIndexInContainer() + 1
    } else {
      this.nextIndexValue = Math.max(this.nextIndexValue, this.maxIndexInContainer() + 1)
    }
  }

  add(event) {
    event.preventDefault()
    const index = this.nextIndexValue
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.nextIndexValue = index + 1
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.currentTarget.closest(".nested-form-wrapper")
    if (!wrapper) return

    const destroyInput = wrapper.querySelector('input[name$="[_destroy]"]')
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      if (destroyInput) destroyInput.value = "1"
      wrapper.style.display = "none"
    }
  }

  maxIndexInContainer() {
    const nodes = this.containerTarget.querySelectorAll(
      "input[name*='[fields_attributes]'], select[name*='[fields_attributes]'], textarea[name*='[fields_attributes]']"
    )
    let max = -1
    nodes.forEach((el) => {
      const m = el.name.match(/\[fields_attributes]\[(\d+)]/)
      if (m) max = Math.max(max, parseInt(m[1], 10))
    })
    return max
  }
}